import React from 'react';
import PropTypes from 'prop-types';
import Loader from '@clearscore/rainbow.loader';
import Container from '@clearscore/rainbow.container';
import cx from 'classnames';

import styles from './page-loader.css';

const THEMES = {
    DARK: 'dark',
    LIGHT: 'light',
};

const PageLoader = ({ theme, hasContainer, containerTheme }) => {
    const loader = (
        <div
            className={cx(
                styles.loader,
                { [styles.dark]: theme === THEMES.DARK },
                { [styles.light]: theme === THEMES.LIGHT },
            )}
            data-qa="page-loader"
        >
            <Loader />
            <span className={styles.srOnly}>loading</span>
        </div>
    );

    if (!hasContainer) return loader;

    return (
        <Container isFullHeight theme={containerTheme}>
            {loader}
        </Container>
    );
};

PageLoader.propTypes = {
    theme: PropTypes.oneOf(Object.values(THEMES)),
    hasContainer: PropTypes.bool,
    containerTheme: PropTypes.oneOf(Object.values(Container.themes)),
};

PageLoader.defaultProps = {
    theme: THEMES.LIGHT,
    hasContainer: false,
    containerTheme: Container.themes.LIGHT,
};

PageLoader.THEMES = THEMES;

export default PageLoader;
